import React from "react";
import PropTypes from "prop-types";

const LargeSpinner = ({ text, loading }) =>
  loading === true ? (
    <React.Fragment>
      <span
        className="spinner spinner-border spinner-border-lg position-absolute"
        style={{ left: "50%", top: "50%" }}
      />
      {text}
    </React.Fragment>
  ) : (
    ""
  );

  LargeSpinner.propTypes = {
  text: PropTypes.string,
  loading: PropTypes.bool.isRequired,
};

export default LargeSpinner;


// WEBPACK FOOTER //
// ./src/components/common/LargeSpinner.jsx